import { brand } from '@/brands';
import { useAppDispatch } from '@/hooks';
import { useGetContactSupportQuery } from '@/store/api/userApi';
import { setAgeModalOpen } from '@/store/slices/uiSlice';
import { useNavigate } from 'react-router-dom';

const Footer = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  useGetContactSupportQuery();

  return (
    <footer className="site-footer">
      <style>{`
        .site-footer {
          width: 100%;
          font-family: 'Roboto', 'Roboto Condensed', sans-serif;
        }

        /* ── Blue support section ── */
        .ftr-top {
          width: 100%;
          min-height: 56px;
          background: #0088CC;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 14px 12px;
          box-sizing: border-box;
        }
        .ftr-title {
          margin: 0;
          color: #fff;
          font-size: 20px;
          font-weight: 700;
          letter-spacing: 0.3px;
          text-align: center;
        }
        /* ── White section ── */
        .footer-bottom {
          width: 100%;
          background: #FFFFFF;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 12px;
          padding: 14px 8px;
          box-sizing: border-box;
        }
        .ftr-safe {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 12px;
        }
        .ftr-secure {
          height: 46px;
          width: auto;
          object-fit: contain;
          flex-shrink: 0;
        }
        .ftr-safe-text { line-height: 1.3; }
        .ftr-safe-title {
          margin: 0;
          font-size: 15px;
          font-weight: 700;
          color: #111827;
        }
        .ftr-safe-desc {
          margin: 0;
          font-size: 13px;
          color: #374151;
        }

        .ftr-badges {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 12px;
        }
        .ftr-badge {
          width: 30px;
          height: 30px;
          object-fit: contain;
        }
        .ftr-badge.age { cursor: pointer; }

        .ftr-copy {
          margin: 0;
          text-align: center;
          font-size: 12px;
          color: #111827;
        }

        /* ── Responsive ── */
        @media (max-width: 480px) {
          .ftr-title { font-size: 18px; }
          .ftr-safe { gap: 10px; }
          .ftr-secure { height: 42px; }
          .ftr-safe-title { font-size: 14px; }
          .ftr-safe-desc { font-size: 12px; }
          .ftr-copy { font-size: 11px; }
        }
      `}</style>

      {/* Blue support section */}
      <div className="ftr-top">
        <h3 className="ftr-title">24X7 Support</h3>
      </div>

      {/* White section */}
      <div className="footer-bottom">
        <div className="ftr-safe">
          <img src="/images/secure.png" alt="SSL Secure" className="ftr-secure" />
          <div className="ftr-safe-text">
            <p className="ftr-safe-title">100% SAFE</p>
            <p className="ftr-safe-desc">Protected connection and encrypted data.</p>
          </div>
        </div>

        <div className="ftr-badges">
          <img
            onClick={() => dispatch(setAgeModalOpen(true))}
            src="/images/18plus.png"
            alt="18+"
            className="ftr-badge age"
          />
          <img
            onClick={() => navigate('/blank')}
            src="/images/gamecare.png"
            alt="GameCare"
            className="ftr-badge age"
          />
          <img
            onClick={() => navigate('/blank')}
            src="/images/gt.png"
            alt="GT"
            className="ftr-badge age"
          />
        </div>

        <p className="ftr-copy">© Copyright 2026. All Rights Reserved. Powered by {brand.name}.</p>
      </div>
    </footer>
  );
};

export default Footer;
